import cx from 'classnames';
import { Icon, Text } from '../../atoms';
import { ConditionalView } from '../../utils/ConditionalView';
import styles from './FormField.module.scss';
import usePresenter from './FormField.presenter';
import { FormFieldProps } from './FormField.types';

const FormField = (props: FormFieldProps) => {
  const {
    label,
    required,
    infoIcon,
    children,
    messageText,
    fieldId,
    variantProps,
    showMessageContainer,
    showErrorIcon,
    showInfoIcon,
  } = usePresenter(props);

  const infoIconView = infoIcon || (
    <Icon className={styles.messageIcon} icon="Info" style="Outlined" size="Small" />
  );

  return (
    <div className={cx(styles.formField, props.className)} {...variantProps}>
      <div className={styles.field}>
        <ConditionalView condition={label}>
          <label className={styles.labelContainer} htmlFor={fieldId}>
            <Text
              className={cx(styles.label, { [styles.required]: required })}
              type="BodySmall"
              weight="Bold"
            >
              {label}
            </Text>
          </label>
        </ConditionalView>
        {children}
      </div>
      <ConditionalView condition={showMessageContainer}>
        <div className={styles.messageContainer}>
          <ConditionalView condition={showErrorIcon}>
            <Icon className={styles.messageIcon} icon="Info" style="Outlined" size="Small" />
          </ConditionalView>
          <ConditionalView condition={showInfoIcon}>
            {infoIconView}
          </ConditionalView>
          <Text className={styles.message} type="BodySmall" weight="Regular">
            {messageText}
          </Text>
        </div>
      </ConditionalView>
    </div>
  );
};

export default FormField;
